import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createTeam,
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  diamQueryKeys,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { mapCreateTeamApiRequest } from './mapTeamApiRequest';
import { CreateTeamSubmitPayload } from './types';

export function useCreateTeam() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateTeamSubmitPayload) => {
      const idToken = await getIdToken();
      return createTeam(apiUrl, idToken, mapCreateTeamApiRequest(payload));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['diam', 'teams', 'page'] });
      queryClient.invalidateQueries({
        queryKey: diamQueryKeys.teamTree(DIAM_TEAM_ID),
      });
    },
  });
}
